import { motion } from 'framer-motion';
import { Users, Search } from 'lucide-react';

function EmptyState({ 
  icon: Icon = Users, 
  title, 
  description, 
  actionLabel, 
  onAction 
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col items-center justify-center py-16 px-4 text-center"
    >
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 0.2, type: 'spring' }}
        className="mb-6 p-6 rounded-full bg-gray-100 dark:bg-gray-800"
      >
        <Icon size={48} className="text-gray-400 dark:text-gray-500" />
      </motion.div>
      
      <motion.h3
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
        className="text-xl font-semibold text-gray-900 dark:text-white mb-2"
      >
        {title}
      </motion.h3>
      
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
        className="text-gray-600 dark:text-gray-400 max-w-md mb-6"
      >
        {description}
      </motion.p>
      
      {actionLabel && onAction && (
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={onAction}
          className="px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors shadow-md"
        >
          {actionLabel}
        </motion.button>
      )}
    </motion.div>
  );
}

export function EmptySearchState({ searchTerm }) {
  return (
    <EmptyState
      icon={Search}
      title="No employees found"
      description={`We couldn't find any employees matching "${searchTerm}". Try adjusting your search terms.`}
    />
  );
}

export default EmptyState;
